import endpoints from '../endpoints';
import StoreFromFile from './StoreFromFile';

class ProductsStore extends StoreFromFile {
  constructor(name) {
    super(name);
    this.storeSavedName = 'XXSProducts';
    this.endpoint = endpoints.products.get;
  }
}

export default ProductsStore;
